import { Modal } from '../../shared/modal';
import Notification from '../../shared/notification';
import LoadCustomerCart from '../views/load-customer-cart';
import { LocalQuote } from '../local-quote';

export const handleLoadCartClick = async (e, app) => {
    const modal = new Modal({
        containerId: 'load-customer-cart-modal',
        maxWidth: '500px',
    });

    const notification = new Notification({ type: 'loading' });

    notification.open();

    const cartId = (await app.service.getCartDetails())?.id ?? LocalQuote.WILDCARD;

    // Prepare data for LoadCustomerCart
    const data = {
        sellerCartId: cartId,
        customerCartId: null, // Will be set based on TCC input
        tcc: app.session.tcc
    };

    const loadCartModal = new LoadCustomerCart(modal, data, app);
    loadCartModal.load();
    modal.open();
    notification.close();

    app.menu.getHandler().close();
};